import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    kit : {},
    overallTimeConsumed: 0,
    kitName : "",
    kitId : 0
};

const kitSlice = createSlice({
    name:'kit',
    initialState,
    reducers : {
        setKit : (state, {payload}) => {
            state.kit = payload;
        },
        setOverallTimeConsumed : (state, {payload}) => {
            state.overallTimeConsumed = payload;
        },
        setKitName : (state, {payload}) => {
            state.kitName = payload;
        },
        
        setKitId :(state ,{payload}) =>{
            state.kitId = payload
        }
    }
})

export const {setKit, setOverallTimeConsumed, setKitId ,setKitName} = kitSlice.actions;

export const getKit = (state) => state.kit.kit;
export const getOverallTimeConsumed = (state) => state.kit.overallTimeConsumed;
export const getKitName = (state) => state.kit.kitName;
export const getKitId =(state) => state.kit.kitId;

export default kitSlice.reducer;